import { useEffect, useRef, useState } from "react";
import { ChevronDown, Search } from "lucide-react";

export default function SearchSelect({ label, htmlFor, testid, placeholder, options, value, onChange, disabled, loading }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);
  const selected = options.find((o) => String(o.value) === String(value));

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const filtered = q ? options.filter((o) => o.label.toUpperCase().includes(q.toUpperCase())) : options;

  return (
    <div ref={ref} className="relative">
      <label className="text-sm font-semibold text-slate-700 mb-2 block" htmlFor={htmlFor}>{label}</label>
      <button type="button" id={htmlFor} data-testid={testid} disabled={disabled}
        onClick={() => { setOpen((o) => !o); setQ(""); }}
        className="w-full h-14 px-4 text-lg bg-white border border-slate-300 rounded-xl focus:border-emerald-600 focus:ring-2 focus:ring-emerald-600/20 outline-none transition flex items-center justify-between gap-2 disabled:bg-slate-100">
        <span className={`truncate text-left ${selected ? "text-slate-900" : "text-slate-400"}`}>
          {loading ? "Cargando..." : selected ? selected.label : placeholder}
        </span>
        <ChevronDown className="w-5 h-5 text-slate-400 shrink-0" />
      </button>
      {open && !disabled && (
        <div className="absolute z-[60] left-0 right-0 mt-1 bg-white border border-slate-200 rounded-xl shadow-xl overflow-hidden" data-testid={`${testid}-dropdown`}>
          <div className="p-2 border-b border-slate-100 flex items-center gap-2">
            <Search className="w-4 h-4 text-slate-400 shrink-0" />
            <input autoFocus data-testid={`${testid}-search`} className="w-full h-9 outline-none text-base bg-transparent"
              placeholder="Escribi para buscar..." value={q} onChange={(e) => setQ(e.target.value)} />
          </div>
          <div className="max-h-56 overflow-y-auto overscroll-contain">
            {filtered.slice(0, 120).map((o) => (
              <button key={o.value} type="button" data-testid={`${testid}-opt-${o.value}`}
                onClick={() => { onChange(o); setOpen(false); }}
                className={`w-full text-left px-4 py-3 text-base hover:bg-emerald-50 transition ${String(o.value) === String(value) ? "bg-emerald-50 font-semibold" : ""}`}>
                {o.label}
              </button>
            ))}
            {filtered.length > 120 && <p className="px-4 py-2 text-xs text-slate-400 bg-slate-50 border-t border-slate-100">Hay mas resultados: escribi para refinar la busqueda</p>}
            {!filtered.length && <p className="px-4 py-3 text-sm text-slate-400">No encontramos esa opcion</p>}
          </div>
        </div>
      )}
    </div>
  );
}
